// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import OrchardGoods from "./OrchardGoods";


const {ccclass, property} = cc._decorator;

@ccclass
export default class OrchardGoodsAddWater extends OrchardGoods {

    @property({tooltip: '添加水长度'})
    waterLen: number = 0;

    @property(cc.Node)
    sprWater: cc.Node = null;

    protected bGoodsValid = true;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    collideEffect() {
        this.bGoodsValid = false;

        if (this.sprWater) {
            cc.tween(this.sprWater)
            .to(0.5, {
                height: 0
            })
            .start();
        }
    }

    getAddWaterLen() {
        return this.waterLen;
    }

    // update (dt) {}
}
